<section class="standard-section how-to-play">
  <article class="content-wrap txt-center">
    <h2 class="uppercase margin-bottom-40 normal-3">
      {{'howDoIPlay.title' | translate }}
    </h2>
    <ul *ngIf="lottoId!==undefined" class="steps-list relative-left full-width bullets-none">
      <li *ngFor="let item of ('howDoIPlay.' + lottoId + '.steps' | translate); let i = index" class="relative-left">
        <figure class="step-img lot-id-{{'id' | translate}} inline-block relative-left">
          <div class="{{system}}" *ngIf=" i == 1 ">
            <div class="logo">
              <app-logo-lotto></app-logo-lotto>
            </div>
            <span class="lotto-name relative-left">
              {{lottoName}}
              <small class="block">{{country}}</small>
            </span>
          </div>
        </figure>
        <div class="step-content-box relative-left full-width margin-top-15 txt-center">
          <h4 class=" bg-product-{{'id' | translate}} light-2 uppercase">{{item.title}}</h4>
          <div class="step-text-wrap arial relative-left padding-left-right-20 bg-light-2 full-width flex row wrap y-items-center x-content-center">
            <p>
              {{item.text}}
            </p>
          </div>
        </div>
        <p
          class="step-list-index absolute circle arial light-2 txt-center"
          [ngClass]="{'bg-normal-7' : system == 'wt', 'bg-normal-12' : system == 'ltk'}"
        >
          {{i + 1}}
        </p>
      </li>
    </ul>
  </article>
</section>
